import { createSlice } from '@reduxjs/toolkit';

const initialState = { payments: null, status: 'idle', error: null };

const subscriptionPaymentsSlice = createSlice({
  name: 'subscriptionPayment',
  initialState,
  reducers: {
    subscriptionPaymentRequest(state) {
      state.status = 'loading';
      state.error = null;
    },
    subscriptionPaymentSuccess(state, action) {
      state.status = 'succeeded';
      state.payments = action.payload;
    },
    subscriptionPaymentFailure(state, action) {
      state.status = 'failed';
      state.error = action.payload;
    },
    subscriptionPaymentReset(state) {
      state.status = 'idle';
      state.error = null;
      state.payments = null;
    },
  },
});

export const subscriptionPaymentAction = subscriptionPaymentsSlice.actions;
export default subscriptionPaymentsSlice;